<template>
    <multiselect
        v-model="bankAccount"
        :options="banks.accounts"
        track-by="uuid"
        :multiple="false"
        :allowEmpty="true"
        placeholder="Cuenta Bancaria"
        selectedLabel=""
        selectLabel=""
        deselectLabel=""
        @select="notifyChange">
        <template slot="singleLabel" slot-scope="{ option }">
            <span v-if="!!option.bank">{{ option.bank.name }}</span><br/>
            <small>{{ option.ccc }}</small>
        </template>
        <template slot="option" slot-scope="{ option }">
            <span v-if="!!option.bank">{{ option.bank.name }}</span><br/>
            <small>{{ option.ccc }}</small>
        </template>
    </multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {mapState} from 'vuex'

    export default {
        name: "BankAccountSelector",
        props: {
            value: Object
        },
        components: {
            Multiselect
        },
        data: function () {
            return {
                bankAccount: (!!this.value && !!this.value.uuid) ? this.value : null
            }
        },
        mounted() {
            this.$store.dispatch('loadBanksAccounts');
        },
        computed: {
            ...mapState([
                'banks'
            ])
        },
        methods: {
            notifyChange(bankAccount) {
                this.$emit('input', bankAccount);
            }
        },
        watch: {
            value: function () {
                this.bankAccount = this.value;
            }
        }
    }
</script>

<style scoped>

</style>